import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ApproveProposalButton from '~/client-flow/components/ApproveProposalButton';
import { StepPage } from '~/client-flow/components/StepPage';
import { useResponsive } from '~/client-flow/contexts';
import { useStore, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import { AgreementTerms } from '../AgreementTerms/AgreementTerms';
import { COBStep, getNextStepButtonText, getStepName, isApproveProposalDisabled, stepsTextsPath } from '../ClientOnboarding.utils';
import { nextStepButtonTextsPath } from '../ClientOnboardingInnerV2/ClientOnboardingV2.utils';
import { useCobConfig } from '../CobConfigContext';
export const { ApproveTermsStepTestIds } = getTestIds();
export default function ApproveTermsStep(param) {
    let { isLastStep, selectedBundleID, disabledReason, approveAgreementStatus, selectedOptionalServices, previewStatus, onDone, onBack, approveAgreement } = param;
    const { relationship, isPreview } = useCobConfig();
    const { logBI } = useStoreActions();
    const { isDesktop } = useResponsive();
    const userId = useStore(selectors.user.id);
    const role = useStore(selectors.user.role);
    const { t: stepsTexts } = useLocaleKeys(stepsTextsPath);
    const { t: clientFlowTexts } = useLocaleKeys(nextStepButtonTextsPath);
    const nextStepButtonText = getNextStepButtonText(COBStep.approveTerms, relationship, clientFlowTexts);
    const disabled = isApproveProposalDisabled(disabledReason, isPreview, relationship, userId, role);
    return /*#__PURE__*/ _jsx(StepPage, {
        header: getStepName(COBStep.approveTerms, relationship, stepsTexts),
        primaryBtn: isLastStep ? /*#__PURE__*/ _jsx(ApproveProposalButton, {
            onDone: approveAgreement,
            previewStatus: previewStatus,
            isDesktop: isDesktop,
            relationship: relationship,
            testId: relationship.isSample ? ApproveTermsStepTestIds.TestAgreementPrimaryNextButton() : ApproveTermsStepTestIds.PrimaryNextButton(),
            disabled: disabled || approveAgreementStatus === 'loading'
        }) : /*#__PURE__*/ _jsx(Button, {
            onClick: ()=>{
                !isPreview && logBI(10822);
                onDone();
            },
            children: nextStepButtonText
        }),
        disabledReason: disabled ? disabledReason : undefined,
        onBackBtnClick: onBack,
        testId: ApproveTermsStepTestIds.Root(),
        children: /*#__PURE__*/ _jsx(AgreementTerms, {
            relationship: relationship,
            selectedBundleID: selectedBundleID,
            selectedOptionalServices: selectedOptionalServices
        })
    });
}
